<template>
  <div class="">
    <div v-show="show" class="success">{{msg}}</div>
  </div>
</template>
 
<script>
import { H5Share } from '@/api.js'
export default {
  components: {
  },
  data () {
    return {
      msg: '分享成功',
      show: false,
      duration: 3000,
    }
  },
  mounted () {
    this.getWxData()
  },
  methods: {
    setTimer() {
      let that = this;
      setTimeout(() => {
        that.show = false
      }, that.duration)
    },
    getWxData(){
      let that = this;
      H5Share(window.location.protocol+'//api1.cyzone.cn/v1/member/tools/jsSign?temp=' + Math.random(),{
          url: window.location.href
      }).then(res => {
        var json = res.data;

        var opt = {
          title: '红杉午夜FM',
          desc: '万里挑一，16个有趣有胆有识的灵魂，揭秘斜杠养成记。',
          imgUrl : require('@/assets/share.jpg'),
          link: window.location.href,
          success: function(){
            that.show = true
            that.setTimer();
          }
        };

        wx.config( res.data );
        wx.ready(function(){
          // 分享到朋友圈
          // wx.updateAppMessageShareData( opt );
          // wx.updateTimelineShareData( opt );
          wx.onMenuShareTimeline( opt );
          // 分享到朋友
          wx.onMenuShareAppMessage( opt );
          // 分享到QQ
          wx.onMenuShareQQ( opt );
          // 分享到QQ空间
          wx.onMenuShareQZone( opt );
        });
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.success{
  position: fixed;
  top: 1rem;
  left: 50%;
  width: 4rem;
  margin-left: -2rem;
  font-size: .22rem;
  z-index: 99;
  background-color: #f0f9eb;
  color: #67c23a;
  border-radius: 4px;
  line-height: .6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/share.vue